export const LEGAL_VERSION = "2026-07-23";
export const LEGAL_EFFECTIVE_DATE = "23 July 2026";
